import React from 'react';

import SortOption from './SortOption';

import { sortWrapper, options, hrLine } from './styles.module.css';

const CategorySearchSortComponent = (props) => {
  const { mainSortCategoriesArray, activeClass, showBorder } = props;
  let classWrapper = [sortWrapper];
  if (showBorder) {
    classWrapper = classWrapper.concat(hrLine);
  }

  return (
    <div className={classWrapper.join(' ')}>
      <span>Sort By:</span>
      <div className={options}>
        {mainSortCategoriesArray &&
          mainSortCategoriesArray.map((categoryConfig) => (
            <SortOption
              activeClass={activeClass}
              sortMainCategoryId={categoryConfig.id}
              options={categoryConfig.options}
              key={categoryConfig.id}
              label={categoryConfig.label}
            />
          ))}
      </div>
    </div>
  );
};

CategorySearchSortComponent.propTypes = {};

CategorySearchSortComponent.defaultProps = {};

export default CategorySearchSortComponent;
